module.exports = __webpack_public_path__ + "img/x.0adc16ff.svg";